var map = {
	"./AD.png": 822,
	"./AE.png": 823,
	"./AF.png": 824,
	"./AFG.png": 825,
	"./AG.png": 826,
	"./AGO.png": 827,
	"./AI.png": 828,
	"./AIA.png": 829,
	"./AL.png": 830,
	"./ALB.png": 831,
	"./AM.png": 832,
	"./AND.png": 833,
	"./AO.png": 834,
	"./AR.png": 835,
	"./ARE.png": 836,
	"./ARG.png": 837,
	"./ARM.png": 838,
	"./AS.png": 839,
	"./ASEAN.png": 840,
	"./AT.png": 841,
	"./ATG.png": 842,
	"./AU.png": 843,
	"./AUS.png": 844,
	"./AUT.png": 845,
	"./AZ.png": 846,
	"./AZE.png": 847,
	"./BA.png": 848,
	"./BB.png": 849,
	"./BD.png": 850,
	"./BDI.png": 851,
	"./BE.png": 852,
	"./BEL.png": 853,
	"./BEN.png": 854,
	"./BF.png": 855,
	"./BFA.png": 856,
	"./BG.png": 857,
	"./BGD.png": 858,
	"./BGR.png": 859,
	"./BH.png": 860,
	"./BHR.png": 861,
	"./BHS.png": 862,
	"./BI.png": 863,
	"./BIH.png": 864,
	"./BJ.png": 865,
	"./BLR.png": 866,
	"./BLZ.png": 867,
	"./BM.png": 868,
	"./BMU.png": 869,
	"./BN.png": 870,
	"./BO.png": 871,
	"./BOL.png": 872,
	"./BR.png": 873,
	"./BRA.png": 874,
	"./BRB.png": 875,
	"./BRN.png": 876,
	"./BS.png": 877,
	"./BT.png": 878,
	"./BTN.png": 879,
	"./BW.png": 880,
	"./BWA.png": 881,
	"./BY.png": 882,
	"./BZ.png": 883,
	"./CA.png": 884,
	"./CAF.png": 885,
	"./CAN.png": 886,
	"./CARICOM.png": 887,
	"./CD.png": 888,
	"./CF.png": 889,
	"./CG.png": 890,
	"./CH.png": 891,
	"./CHE.png": 892,
	"./CHL.png": 893,
	"./CHN.png": 894,
	"./CI.png": 895,
	"./CIV.png": 896,
	"./CK.png": 897,
	"./CL.png": 898,
	"./CM.png": 899,
	"./CMR.png": 900,
	"./CN.png": 901,
	"./CO.png": 902,
	"./COD.png": 903,
	"./COG.png": 904,
	"./COK.png": 905,
	"./COL.png": 906,
	"./COM.png": 907,
	"./CPV.png": 908,
	"./CR.png": 909,
	"./CRI.png": 910,
	"./CU.png": 911,
	"./CUB.png": 912,
	"./CV.png": 913,
	"./CW.png": 914,
	"./CY.png": 915,
	"./CYM.png": 916,
	"./CYP.png": 917,
	"./CZ.png": 918,
	"./CZE.png": 919,
	"./Commonwealth of Nations.png": 920,
	"./DE.png": 921,
	"./DEU.png": 922,
	"./DJ.png": 923,
	"./DJI.png": 924,
	"./DK.png": 925,
	"./DM.png": 926,
	"./DMA.png": 927,
	"./DNK.png": 928,
	"./DO.png": 929,
	"./DOM.png": 930,
	"./DZ.png": 931,
	"./DZA.png": 932,
	"./EC.png": 933,
	"./ECU.png": 934,
	"./EE.png": 935,
	"./EG.png": 936,
	"./EGY.png": 937,
	"./ENG.png": 938,
	"./ER.png": 939,
	"./ERI.png": 940,
	"./ES.png": 941,
	"./ESP.png": 942,
	"./EST.png": 943,
	"./ET.png": 944,
	"./ETH.png": 945,
	"./EU.png": 946,
	"./FI.png": 947,
	"./FIN.png": 948,
	"./FJ.png": 949,
	"./FJI.png": 950,
	"./FM.png": 951,
	"./FR.png": 952,
	"./FRA.png": 953,
	"./FSM.png": 954,
	"./GA.png": 955,
	"./GAB.png": 956,
	"./GB.png": 957,
	"./GBR.png": 958,
	"./GD.png": 959,
	"./GE.png": 960,
	"./GEO.png": 961,
	"./GER.png": 962,
	"./GH.png": 963,
	"./GHA.png": 964,
	"./GIN.png": 965,
	"./GL.png": 966,
	"./GM.png": 967,
	"./GMB.png": 968,
	"./GN.png": 969,
	"./GNB.png": 970,
	"./GNQ.png": 971,
	"./GP.png": 972,
	"./GQ.png": 973,
	"./GR.png": 974,
	"./GRC.png": 975,
	"./GRD.png": 976,
	"./GRL.png": 977,
	"./GT.png": 978,
	"./GTM.png": 979,
	"./GU.png": 980,
	"./GUM.png": 981,
	"./GUY.png": 982,
	"./GW.png": 983,
	"./GY.png": 984,
	"./HK.png": 985,
	"./HKG.png": 986,
	"./HN.png": 987,
	"./HND.png": 988,
	"./HR.png": 989,
	"./HRV.png": 990,
	"./HT.png": 991,
	"./HTI.png": 992,
	"./HU.png": 993,
	"./HUN.png": 994,
	"./ID.png": 995,
	"./IE.png": 996,
	"./IL.png": 997,
	"./IN.png": 998,
	"./INA.png": 999,
	"./IND.png": 1000,
	"./IQ.png": 1001,
	"./IR.png": 1002,
	"./IRL.png": 1003,
	"./IRN.png": 1004,
	"./IRQ.png": 1005,
	"./IS.png": 1006,
	"./ISL.png": 1007,
	"./ISR.png": 1008,
	"./IT.png": 1009,
	"./ITA.png": 1010,
	"./JAM.png": 1011,
	"./JM.png": 1012,
	"./JO.png": 1013,
	"./JOR.png": 1014,
	"./JP.png": 1015,
	"./JPN.png": 1016,
	"./KAZ.png": 1017,
	"./KE.png": 1018,
	"./KEN.png": 1019,
	"./KG.png": 1020,
	"./KGZ.png": 1021,
	"./KH.png": 1022,
	"./KHM.png": 1023,
	"./KI.png": 1024,
	"./KIR.png": 1025,
	"./KM.png": 1026,
	"./KN.png": 1027,
	"./KNA.png": 1028,
	"./KOR.png": 1029,
	"./KP.png": 1030,
	"./KR.png": 1031,
	"./KW.png": 1032,
	"./KWT.png": 1033,
	"./KY.png": 1034,
	"./KZ.png": 1035,
	"./LA.png": 1036,
	"./LAO.png": 1037,
	"./LAS.png": 1038,
	"./LB.png": 1039,
	"./LBN.png": 1040,
	"./LBR.png": 1041,
	"./LBY.png": 1042,
	"./LC.png": 1043,
	"./LCA.png": 1044,
	"./LI.png": 1045,
	"./LIE.png": 1046,
	"./LK.png": 1047,
	"./LKA.png": 1048,
	"./LR.png": 1049,
	"./LS.png": 1050,
	"./LSO.png": 1051,
	"./LT.png": 1052,
	"./LTU.png": 1053,
	"./LU.png": 1054,
	"./LUX.png": 1055,
	"./LV.png": 1056,
	"./LVA.png": 1057,
	"./LY.png": 1058,
	"./MA.png": 1059,
	"./MAC.png": 1060,
	"./MAR.png": 1061,
	"./MC.png": 1062,
	"./MCO.png": 1063,
	"./MD.png": 1064,
	"./MDA.png": 1065,
	"./MDG.png": 1066,
	"./MDV.png": 1067,
	"./ME.png": 1068,
	"./MEX.png": 1069,
	"./MG.png": 1070,
	"./MH.png": 1071,
	"./MHL.png": 1072,
	"./MK.png": 1073,
	"./MKD.png": 1074,
	"./ML.png": 1075,
	"./MLI.png": 1076,
	"./MLT.png": 1077,
	"./MM.png": 1078,
	"./MMR.png": 1079,
	"./MN.png": 1080,
	"./MNE.png": 1081,
	"./MNG.png": 1082,
	"./MO.png": 1083,
	"./MOZ.png": 1084,
	"./MP.png": 1085,
	"./MQ.png": 1086,
	"./MR.png": 1087,
	"./MRT.png": 1088,
	"./MS.png": 1089,
	"./MT.png": 1090,
	"./MU.png": 1091,
	"./MUS.png": 1092,
	"./MV.png": 1093,
	"./MW.png": 1094,
	"./MWI.png": 1095,
	"./MX.png": 1096,
	"./MY.png": 1097,
	"./MYS.png": 1098,
	"./MZ.png": 1099,
	"./NA.png": 1100,
	"./NAM.png": 1101,
	"./NC.png": 1102,
	"./NCL.png": 1103,
	"./NE.png": 1104,
	"./NER.png": 1105,
	"./NG.png": 1106,
	"./NGA.png": 1107,
	"./NI.png": 1108,
	"./NIC.png": 1109,
	"./NIU.png": 1110,
	"./NL.png": 1111,
	"./NLD.png": 1112,
	"./NO.png": 1113,
	"./NOR.png": 1114,
	"./NP.png": 1115,
	"./NPL.png": 1116,
	"./NR.png": 1117,
	"./NRU.png": 1118,
	"./NSLF.png": 1119,
	"./NU.png": 1120,
	"./NZ.png": 1121,
	"./NZL.png": 1122,
	"./OEA.png": 1123,
	"./OM.png": 1124,
	"./OTAN.png": 1125,
	"./PA.png": 1126,
	"./PAK.png": 1127,
	"./PAN.png": 1128,
	"./PE.png": 1129,
	"./PER.png": 1130,
	"./PF.png": 1131,
	"./PG.png": 1132,
	"./PH.png": 1133,
	"./PHL.png": 1134,
	"./PK.png": 1135,
	"./PL.png": 1136,
	"./PLW.png": 1137,
	"./PM.png": 1138,
	"./PNG.png": 1139,
	"./POL.png": 1140,
	"./PR.png": 1141,
	"./PRI.png": 1142,
	"./PRK.png": 1143,
	"./PRT.png": 1144,
	"./PRY.png": 1145,
	"./PS.png": 1146,
	"./PSE.png": 1147,
	"./PT.png": 1148,
	"./PW.png": 1149,
	"./PY.png": 1150,
	"./PYF.png": 1151,
	"./QA.png": 1152,
	"./QAT.png": 1153,
	"./RO.png": 1154,
	"./ROM.png": 1155,
	"./ROU.png": 1156,
	"./RS.png": 1157,
	"./RU.png": 1158,
	"./RUS.png": 1159,
	"./RW.png": 1160,
	"./RWA.png": 1161,
	"./SA.png": 1162,
	"./SAU.png": 1163,
	"./SB.png": 1164,
	"./SC.png": 1165,
	"./SD.png": 1166,
	"./SDN.png": 1167,
	"./SE.png": 1168,
	"./SEN.png": 1169,
	"./SG.png": 1170,
	"./SGP.png": 1171,
	"./SI.png": 1172,
	"./SK.png": 1173,
	"./SL.png": 1174,
	"./SLB.png": 1175,
	"./SLE.png": 1176,
	"./SLV.png": 1177,
	"./SM.png": 1178,
	"./SMR.png": 1179,
	"./SN.png": 1180,
	"./SO.png": 1181,
	"./SOM.png": 1182,
	"./SPC.png": 1183,
	"./SPM.png": 1184,
	"./SR.png": 1185,
	"./SRB.png": 1186,
	"./SS.png": 1187,
	"./SSD.png": 1188,
	"./ST.png": 1189,
	"./STP.png": 1190,
	"./SUR.png": 1191,
	"./SV.png": 1192,
	"./SVK.png": 1193,
	"./SVN.png": 1194,
	"./SWE.png": 1195,
	"./SWZ.png": 1196,
	"./SY.png": 1197,
	"./SYC.png": 1198,
	"./SYR.png": 1199,
	"./SZ.png": 1200,
	"./TC.png": 1201,
	"./TCD.png": 1202,
	"./TD.png": 1203,
	"./TG.png": 1204,
	"./TGO.png": 1205,
	"./TH.png": 1206,
	"./THA.png": 1207,
	"./TJ.png": 1208,
	"./TJK.png": 1209,
	"./TK.png": 1210,
	"./TKM.png": 1211,
	"./TL.png": 1212,
	"./TLS.png": 1213,
	"./TM.png": 1214,
	"./TN.png": 1215,
	"./TO.png": 1216,
	"./TON.png": 1217,
	"./TR.png": 1218,
	"./TRI.png": 1219,
	"./TT.png": 1220,
	"./TTO.png": 1221,
	"./TUN.png": 1222,
	"./TUR.png": 1223,
	"./TUV.png": 1224,
	"./TV.png": 1225,
	"./TW.png": 1226,
	"./TZ.png": 1227,
	"./TZA.png": 1228,
	"./U.N..png": 1229,
	"./UA.png": 1230,
	"./UG.png": 1231,
	"./UGA.png": 1232,
	"./UKR.png": 1233,
	"./URY.png": 1234,
	"./US.png": 1235,
	"./USA.png": 1236,
	"./UY.png": 1237,
	"./UZ.png": 1238,
	"./UZB.png": 1239,
	"./VA.png": 1240,
	"./VAT.png": 1241,
	"./VC.png": 1242,
	"./VCT.png": 1243,
	"./VE.png": 1244,
	"./VEN.png": 1245,
	"./VG.png": 1246,
	"./VI.png": 1247,
	"./VN.png": 1248,
	"./VNM.png": 1249,
	"./VU.png": 1250,
	"./VUT.png": 1251,
	"./WF.png": 1252,
	"./WLF.png": 1253,
	"./WS.png": 1254,
	"./WSM.png": 1255,
	"./YE.png": 1256,
	"./YEM.png": 1257,
	"./ZA.png": 1258,
	"./ZAF.png": 1259,
	"./ZM.png": 1260,
	"./ZMB.png": 1261,
	"./ZW.png": 1262,
	"./ZWE.png": 1263,
	"./default.png": 1264,
	"./СНГ.png": 1265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 169;